import { useWebSocketEvents } from '../../../../../packages/chat-components/src/websocket/hooks';
import { ProjectEntitiesQueryContainer } from './Project.Entities.Query.Container';

type Props = {
  children: React.ReactNode;
  enabled: boolean;
} & IProjectId;

export const ProjectEntitiesContainer = (props: Props) => {
  // Listen for WebSocket events to refresh entities when transcript cleanup completes
  useWebSocketEvents({
    projectId: props.projectId,
    enabled: !!props.projectId && props.enabled,
  });

  return (
    <ProjectEntitiesQueryContainer
      enabled={!!props.projectId && props.enabled}
      projectId={props.projectId}>
      {props.children}
    </ProjectEntitiesQueryContainer>
  );
};

ProjectEntitiesContainer.displayName = 'Project.Entities.Container';